module.exports = __webpack_public_path__ + "static/p4-3ddf507d5aa34977847f5e743183ac81.png";